// extracted by mini-css-extract-plugin
module.exports = {"header":"Heading_header__1ue0u","content":"Heading_content__86GHV","logo":"Heading_logo__wC_WF","contact":"Heading_contact__1b0HH","top":"Heading_top__3IQ7m"};